/* All-Day Hydration LP buy module (sections/amass-lp-buy.liquid).
   Two buttons, one native form: Subscribe & Save (selling_plan = chosen
   frequency) and Buy once (no selling plan). Adds via /cart/add.js, fires the
   same cart:update event Horizon's cart components listen for, then opens the
   native cart drawer -- identical outcome to the PDP add. Also drives the
   sticky mobile bar (visible once the primary button scrolls above the
   viewport, hidden again near the footer). */
(function () {
  /* Gallery lightbox: any [data-lpbuy-zoom] button expands the image it wraps. */
  var box = document.querySelector('[data-lpbuy-lightbox]');
  if (box && typeof box.showModal === 'function') {
    var boxImg = box.querySelector('[data-lpbuy-lightbox-img]');
    function largestSrc(img) {
      var best = img.currentSrc || img.src, bestW = 0, set = img.getAttribute('srcset');
      if (set) {
        set.split(',').forEach(function (c) {
          var parts = c.trim().split(/\s+/), w = parseInt((parts[1] || '').replace('w', ''), 10) || 0;
          if (w > bestW) { bestW = w; best = parts[0]; }
        });
      }
      return best;
    }
    function unlock() { document.body.classList.remove('amass-lightbox-open'); boxImg.removeAttribute('src'); }
    function closeBox() { if (box.open) box.close(); unlock(); }
    document.querySelectorAll('[data-lpbuy-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var img = btn.querySelector('img');
        if (!img) return;
        boxImg.src = largestSrc(img);
        boxImg.alt = img.alt || '';
        box.showModal();
        document.body.classList.add('amass-lightbox-open');
      });
    });
    box.querySelector('[data-lpbuy-lightbox-close]').addEventListener('click', closeBox);
    box.addEventListener('click', function (e) { if (e.target === box) closeBox(); });
    box.addEventListener('close', unlock);
    box.addEventListener('cancel', unlock);
  }

  var root = document.querySelector('[data-amass-lpbuy]');
  if (!root) return;
  var form = root.querySelector('form[data-lpbuy-form]');
  var planInput = form.querySelector('[data-lpbuy-plan]');
  var freq = root.querySelector('[data-lpbuy-freq]');
  var errorEl = root.querySelector('[data-lpbuy-error]');
  var subPlanDefault = planInput.value;
  if (freq) freq.addEventListener('change', function () { planInput.value = freq.value; });

  function rootUrl() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function openDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      if (typeof drawer.open === 'function') { drawer.open(); return; }
      if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return; }
      var dialog = drawer.querySelector('dialog');
      if (dialog && typeof dialog.showModal === 'function') { dialog.showModal(); return; }
    }
    var toggle = document.querySelector('[data-cart-drawer-toggle], a[href$="/cart"], .header-actions__cart-icon');
    if (toggle && toggle.click) toggle.click();
  }
  function refreshCart() {
    fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: root.id || 'amass-lp-buy', data: { source: 'amass-lp-buy', itemCount: cart.item_count } }
        }));
        openDrawer();
      })
      .catch(function () {});
  }
  function add(mode, btn) {
    if (btn.hasAttribute('disabled')) return;
    planInput.value = mode === 'subscribe' ? (freq ? freq.value : subPlanDefault) : '';
    var fd = new FormData(form);
    var sectionIds = [];
    document.querySelectorAll('cart-items-component, cart-drawer-component').forEach(function (el) {
      if (el.dataset && el.dataset.sectionId) sectionIds.push(el.dataset.sectionId);
    });
    if (sectionIds.length) fd.append('sections', sectionIds.join(','));
    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
    btn.classList.add('is-loading');
    fetch(rootUrl() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (item) {
        if (item && item.status) {
          if (errorEl) { errorEl.textContent = item.description || item.message || 'Could not add to cart.'; errorEl.hidden = false; }
          return;
        }
        refreshCart();
      })
      .catch(function () { if (errorEl) { errorEl.textContent = 'Could not add to cart. Please try again.'; errorEl.hidden = false; } })
      .finally(function () { btn.classList.remove('is-loading'); });
  }
  root.querySelectorAll('[data-lpbuy-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); add(btn.getAttribute('data-lpbuy-add'), btn); });
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); });

  var bar = root.querySelector('[data-lpbuy-sticky]');
  var primary = root.querySelector('.amass-lpbuy__primary');
  if (!bar || !primary || typeof IntersectionObserver !== 'function') return;
  var pastPrimary = false, footerIn = false;
  function update() {
    var show = pastPrimary && !footerIn;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { pastPrimary = en.boundingClientRect.bottom < 0; });
    update();
  }, { threshold: 0 }).observe(primary);
  var footer = document.querySelector('.amass-footer') || document.querySelector('.shopify-section-group-footer-group') || document.querySelector('footer');
  if (footer) {
    var check = function () {
      var r = footer.getBoundingClientRect();
      footerIn = r.top < window.innerHeight - bar.offsetHeight;
      update();
    };
    new IntersectionObserver(check, { threshold: 0 }).observe(footer);
    window.addEventListener('scroll', check, { passive: true });
  }
})();
